<template>
  <div v-reached.center="onViewed" class="footer">
    <subscription-block v-if="showSubscription && !LOGGED_IN" />
    <main-block />
    <copyright-block />
    <ldJson
      v-if="isContactsPage"
      :json="ldJsonContactsData"
    />
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';

import ldJson from '@/components/ui-kit/ui-ld-json';
import { cartFooterGtmEvents } from '@/gtm/cart';
import { createGtmEventsProxy } from '@/gtm/gtm-events-utils';

import CopyrightBlock from './components/copyright-block';
import MainBlock from './components/main-block';
import SubscriptionBlock from './components/subscription-block';

export default {
  name: 'app-footer',

  components: {
    ldJson,
    SubscriptionBlock,
    CopyrightBlock,
    MainBlock,
  },

  provide() {
    return { gtmEvents: this.gtmEvents };
  },

  props: {
    location: {
      type: String,
      default: 'footer_menu',
    },
  },

  computed: {
    ...mapGetters({
      MENU: 'menu/mainMenu',
      LOGGED_IN: 'user/loggedIn',
    }),

    ldJsonContactsData() {
      return JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'Organization',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Москва, Россия',
          postalCode: '117420',
          streetAddress: 'ул. Профсоюзная, 61А',
        },
        url: 'https://fundayshop.com/contacts',
        email: 'helpme@fundayshop.com',
        name: 'FUNDAY',
        telephone: '8 800 770-01-01',
        sameAs: [
          'https://vk.com/fundayshop',
          'https://t.me/fundaystores',
          'https://ok.ru/fundayshop',
        ],
        logo: {
          '@type': 'ImageObject',
          url: 'https://cdn.fundayshop.com/upload/content/root_static/ru_funday/statics/logo-funday.jpg',
          width: '120',
          height: '120',
        },
      });
    },

    isContactsPage() {
      return this.$route.name === 'Contacts';
    },

    showSubscription() {
      const route = useRoute();

      return ![
        '/account',
        '/stores',
        '/checkout',
      ].some((p) => route?.fullPath.includes(p));
    },
    gtmEvents() {
      if (this.$route.name === 'Checkout') {
        return cartFooterGtmEvents;
      }

      return createGtmEventsProxy();
    },
  },

  methods: {
    ...mapActions({
      LOAD_MENU: 'menu/loadFooterMenu',
    }),

    onViewed() {
      this.gtmEvents.footerShown();
    },
  },

  serverPrefetch() {
    return this.LOAD_MENU(this.location);
  },
};
</script>

<style lang="scss">
.footer {
  padding-bottom: env(safe-area-inset-bottom, 0);
  box-shadow: inset 0 1px 0 $gray_lu;
}
</style>
